import gql from 'graphql-tag'



export const CREATE_CATEGORY = gql`
    mutation createCategory($categoryName:String!){
        createCategory(categoryName:$categoryName){
            id
            categoryName
            categoryCount
            order
            topComment{
                id
            }
        }
    }
`